import React, { useContext } from 'react';

import DateRangeContext from '@totem/components/common/dateRangePicker/dateRangeContext';
import DateRangePickerExtended from '@totem/components/common/dateRangePicker/dateRangePickerExtended';

const DateRangePickerWithContext = () => {
  const { startDate, endDate, setRange, defaultTimeFrame, allowClear } =
    useContext(DateRangeContext);

  return (
    <DateRangePickerExtended
      startTime={startDate}
      endTime={endDate}
      defaultTimeFrame={defaultTimeFrame}
      allowClear={allowClear}
      onChange={setRange}
    />
  );
};

export default DateRangePickerWithContext;
